
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "jst/outcomes/_calculationMethodExample";
import "i18n!outcomes.outcome_popover";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'outcomes/outcomePopover';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  
  return "-dialog";
  }

function program3(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <div class=\"title\">";
  if (helper = helpers.path) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.path); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div>\n    <div class=\"chart\">\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.ratings)),stack1 == null || stack1 === false ? stack1 : stack1.result_count), {hash:{},inverse:self.program(10, program10, data),fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n    <div class=\"outcome-info\">\n      <div class=\"mastery\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.outcome_popover")
  },data:data},helper ? helper.call(depth0, "mastery_set_at", "Mastery set at", options) : helperMissing.call(depth0, "t", "mastery_set_at", "Mastery set at", options)))
    + ": "
    + escapeExpression((helper = helpers.nf || (depth0 && depth0.nf),options={hash:{
    'format': ("outcomeScore")
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.mastery_points), options) : helperMissing.call(depth0, "nf", (depth0 && depth0.mastery_points), options)))
    + "</div>\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.description), {hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n    ";
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n        <div class=\"chart-image pull-left\"></div>\n        <ol class=\"ratings pull-left\">\n        ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.ratings), {hash:{},inverse:self.noop,fn:self.programWithDepth(5, program5, data, depth0),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </ol>\n      ";
  return buffer;
  }
function program5(depth0,data,depth1) {
  
  var buffer = "", stack1, helper;
  buffer += "\n          <li class=\"rating\"><span class=\"legend-color\"\n            style=\"background-color: ";
  stack1 = helpers['if'].call(depth0, (depth1 && depth1.account_level_scales), {hash:{},inverse:self.program(8, program8, data),fn:self.program(6, program6, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n          />\n            ";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n          </li>\n        ";
  return buffer;
  }
function program6(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += " #";
  if (helper = helpers.color) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.color); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " ";
  return buffer;
  }

function program8(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += " ";
  if (helper = helpers.color) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.color); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " ";
  return buffer;
  }

function program10(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <p><img src=\"/images/pie-chart-disabled.png\" /></p>\n        <p>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.outcome_popover")
  },data:data},helper ? helper.call(depth0, "no_results", "(no results)", options) : helperMissing.call(depth0, "t", "no_results", "(no results)", options)))
    + "</p>\n      ";
  return buffer;
  }

function program12(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "<div class=\"description\">";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</div>";
  return buffer;
  }

function program14(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <div class=\"mastery-details pull-right\" aria-hidden=\"true\">\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.scoreDefined), {hash:{},inverse:self.program(17, program17, data),fn:self.program(15, program15, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n    <div class=\"recent-details\">\n      <div class=\"last-assessment\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "latest_assessment_a85280ef", "Latest Assessment", options) : helperMissing.call(depth0, "t", "latest_assessment_a85280ef", "Latest Assessment", options)))
    + ":&nbsp;\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.result_title), {hash:{},inverse:self.program(21, program21, data),fn:self.program(19, program19, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n      <div class=\"submission-time\">"
    + escapeExpression((helper = helpers.datetimeFormatted || (depth0 && depth0.datetimeFormatted),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.submission_time), options) : helperMissing.call(depth0, "datetimeFormatted", (depth0 && depth0.submission_time), options)))
    + "</div>\n    </div>\n    <div class=\"screenreader-only\">\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.score), {hash:{},inverse:self.program(25, program25, data),fn:self.program(23, program23, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n    ";
  return buffer;
  }
function program15(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <span>"
    + escapeExpression((helper = helpers.nf || (depth0 && depth0.nf),options={hash:{
    'format': ("outcomeScore")
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.roundedScore), options) : helperMissing.call(depth0, "nf", (depth0 && depth0.roundedScore), options)))
    + " / "
    + escapeExpression((helper = helpers.nf || (depth0 && depth0.nf),options={hash:{
    'format': ("outcomeScore")
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.mastery_points), options) : helperMissing.call(depth0, "nf", (depth0 && depth0.mastery_points), options)))
    + "</span>\n        <span class=\"screenreader-only\">\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title': ((depth0 && depth0.title)),
    'statusTooltip': ((depth0 && depth0.statusTooltip)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "outcome_title_has_a_status_of_statustooltip_82d1e6d9", "Outcome: %{title} has a status of %{statusTooltip}", options) : helperMissing.call(depth0, "t", "outcome_title_has_a_status_of_statustooltip_82d1e6d9", "Outcome: %{title} has a status of %{statusTooltip}", options)))
    + "\n        </span>\n        "
    + escapeExpression((helper = helpers.addMasteryIcon || (depth0 && depth0.addMasteryIcon),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.status), options) : helperMissing.call(depth0, "addMasteryIcon", (depth0 && depth0.status), options)))
    + "\n      ";
  return buffer;
  }

function program17(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <span>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "no_score_yet_c94e919b", "No score yet", options) : helperMissing.call(depth0, "t", "no_score_yet_c94e919b", "No score yet", options)))
    + "</span>\n      ";
  return buffer;
  }

function program19(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n          ";
  if (helper = helpers.result_title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.result_title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n        ";
  return buffer;
  }

function program21(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "not_available_until_next_submission_2175158", "Not available until next submission", options) : helperMissing.call(depth0, "t", "not_available_until_next_submission_2175158", "Not available until next submission", options)))
    + "\n        ";
  return buffer;
  }

function program23(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'score': ((depth0 && depth0.score)),
    'mastery_points': ((depth0 && depth0.mastery_points)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "current_mastery_score_score_out_of_mastery_points_fedd343f", "Current Mastery Score: %{score} out of %{mastery_points}", options) : helperMissing.call(depth0, "t", "current_mastery_score_score_out_of_mastery_points_fedd343f", "Current Mastery Score: %{score} out of %{mastery_points}", options)))
    + "\n      ";
  return buffer;
  }

function program25(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "no_score_yet_c94e919b", "No score yet", options) : helperMissing.call(depth0, "t", "no_score_yet_c94e919b", "No score yet", options)))
    + "\n      ";
  return buffer;
  }

  buffer += "<div class=\"outcome-details";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.dialog), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n  <div class=\"line-graph\">\n    <div class=\"screenreader-only\"></div>\n  </div>\n  <div class=\"head-content\" tabindex=\"0\">\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.path), {hash:{},inverse:self.program(14, program14, data),fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n  <div class=\"calculation-method-example method-details content-box pad-box-mini border border-trbl border-round\">\n    ";
  stack1 = self.invokePartial(partials['outcomes/calculationMethodExample'], 'outcomes/calculationMethodExample', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n</div>\n";
  return buffer;
  });
    ;
    
    import brandableCss from 'compiled/util/brandableCss';
    brandableCss.loadStylesheet('jst/outcomes/outcomePopover', {"new_styles_normal_contrast":{"combinedChecksum":"538a4912e7"},"new_styles_high_contrast":{"combinedChecksum":"538a4912e7"},"responsive_layout_normal_contrast":{"combinedChecksum":"538a4912e7"},"responsive_layout_high_contrast":{"combinedChecksum":"538a4912e7"},"new_styles_normal_contrast_rtl":{"combinedChecksum":"4d51acaf87"},"new_styles_high_contrast_rtl":{"combinedChecksum":"4d51acaf87"},"responsive_layout_normal_contrast_rtl":{"combinedChecksum":"4d51acaf87"},"responsive_layout_high_contrast_rtl":{"combinedChecksum":"4d51acaf87"}}[brandableCss.getCssVariant()]);
  ;
    export default templates[name];
  